import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Ссылка - цветом текста, а не primary: primary на светлом фоне не проходит
 * AA для мелкого текста (аудит 2026-09-17). Ссылку отличает ПОДЧЁРКИВАНИЕ,
 * и оно записано здесь явно.
 *
 * До единицы 15 подчёркивание давал класс `link` прежней библиотеки. Она
 * снята - и ссылка внутри абзаца осталась отличима от текста только цветом
 * (1,2:1 к соседнему тексту): axe нашёл это на экране регистрации правилом
 * `link-in-text-block`. Ссылка, неотличимая от текста, - это ссылка,
 * которую не видит ни человек, ни чтец.
 */
export const LINK_CLASS = 'text-foreground font-medium underline underline-offset-4 hover:decoration-primary';
export const LINK_QUIET_CLASS = 'text-foreground/80 underline underline-offset-4 hover:text-foreground';
export function Link({ quiet = false, external = false, children, ...rest }) {
    const externalProps = external ? { target: '_blank', rel: 'noopener noreferrer' } : {};
    return (_jsx("a", { ...rest, ...externalProps, className: quiet ? LINK_QUIET_CLASS : LINK_CLASS, children: children }));
}
//# sourceMappingURL=Link.js.map